export function convertFindstrHitsToMarkers(hits) {
  if (!hits?.length) {
    // BAIL. No hits.
    return [];
  }

  const markers = [];
  hits.forEach((hit) => {
    const latitude = parseFloat(hit.clinic_lat);
    const longitude = parseFloat(hit.clinic_long);
    if (isNaN(latitude) || isNaN(longitude)) {
      console.warn('Invalid coordinates data:', hit);
      // BAIL. Cannot add marker.
      return;
    }

    // To check quickly if there are other activities matching this exact spot.
    const newMarkerId = `${longitude}-${latitude}`;
    const markerWithSamePlace = markers.find(
      (marker) => newMarkerId === marker.markerId
    );
    if (markerWithSamePlace) {
      // Add to already existing marker.
      markerWithSamePlace.activityIds.push(hit.ID);
      if (!Array.isArray(markerWithSamePlace.activities)) {
        markerWithSamePlace.activities = [];
      }
      markerWithSamePlace.activities.push(hit);
    } else {
      // Prepare marker data.
      markers.push({
        longitude,
        latitude,
        markerId: newMarkerId,
        type: hit.post_type,
        icon: '/wp-content/themes/pcnphysio.com/assets/images/svgs/marker.svg',
        activityIds: [hit.ID],
        activities: [hit],
      });
    }
  });

  // Construction des popups
  markers.forEach((marker) => {
    const popupContent = marker.activities
      .map((hit) => getHitPopupContent(hit))
      .join('');

    marker.popup = popupContent;
    delete marker.activities;
  });

  return markers;
}

function getHitPopupContent(hit) {
  let activityHtml =
    '<div class="clinic-item"><div class="clinic-item__inner">';

  activityHtml += '<div class="clinic-item__content-wrapper">';

  if (hit.post_title) {
    activityHtml += `<p class="clinic-item__title heading-size-3">${hit.post_title}</p>`;
  }
  if (hit.address) {
    activityHtml += `<p class="clinic-item__address">${hit.address}</p>`;
  }
  if (hit.phone_number) {
    activityHtml += '<p class="clinic-item__phone">';
    activityHtml += `<span class="phone-value">${hit.phone_number}</span>`;
    activityHtml += '<span class="phone-icon icon-phone-message"></span>';
    activityHtml += '</p>';
  }

  activityHtml += '<div class="clinic-item__buttons">';
  if (hit.online_appointment) {
    activityHtml += `<a class="btn--small" href="${hit.online_appointment}" target="_blank" rel="noopener noreferrer">`;
    activityHtml += `${hit.online_appointment_label || ''}`;
    activityHtml += '</a>';
  }
  activityHtml += `<a class="btn--outline-small" href="${window.location.origin}${hit.permalink}">`;
  activityHtml += `${hit.read_more_label || 'En savoir plus'}`;
  activityHtml += '</a>';
  activityHtml += '</div>';

  activityHtml += '</div></div></div>';
  return activityHtml;
}
